// helpers/getCurrencies.ts
export async function getCurrencies(): Promise<string[]> {
  try {
    const res = await fetch(
      "https://restcountries.com/v3.1/all?fields=currencies"
    );

    if (!res.ok) {
      throw new Error(`Failed to fetch countries: ${res.status}`);
    }

    const data = await res.json();

    // Extract currency codes from the response
    const allCurrencies: string[] = data.flatMap((country: any) =>
      Object.keys(country?.currencies || {})
    );

    // Remove duplicates & filter out empty values
    const uniqueCurrencies = Array.from(new Set(allCurrencies.filter(Boolean)));

    return uniqueCurrencies;
  } catch (error) {
    console.error("Error fetching currencies:", error);
    return [];
  }
}
